import classNames from 'classnames'
import { ComponentProps, ReactElement } from 'react'

interface Props extends ComponentProps<'svg'> {
  color?: string
}

export function IconDragAndDrop({ color = 'currentColor', className, ...props }: Props): ReactElement {
  return (
    <svg
      viewBox="4 4 16 16"
      className={classNames(className, 'w-[1em] h-[1em]')}
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9.5" cy="6.50049" r="1.5" fill={color} />
      <circle cx="14.5" cy="6.50049" r="1.5" fill={color} />
      <circle cx="9.5" cy="11.5005" r="1.5" fill={color} />
      <circle cx="14.5" cy="11.5005" r="1.5" fill={color} />
      <circle cx="9.5" cy="16.5005" r="1.5" fill={color} />
      <circle cx="14.5" cy="16.5005" r="1.5" fill={color} />
    </svg>
  )
}
